import firebase from 'firebase/app';
export function initializeFirebase(options, name) {
    firebase.initializeApp(options, name);
}
//# sourceMappingURL=FirebaseInit.js.map